<script lang="ts">
  import { Episodios, type Episodio } from '../../../lib/api';

  let { limit = 8, onNavigate }: { limit?: number; onNavigate?: (tab: string) => void } = $props();
  let items = $state<Episodio[]>([]);
  let error = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      items = (await Episodios.abiertos('HOSPITALIZACION')).slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<div class="panel">
  <header>
    <h3>Altas pendientes</h3>
    <button type="button" onclick={cargar}>↻</button>
  </header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if items.length === 0 && !error}
    <p class="empty">Sin episodios hospitalarios abiertos.</p>
  {:else}
    <ul>
      {#each items as ep (ep.id)}
        <li>
          <div>
            <strong>Episodio {ep.numero ?? ep.id?.slice(0, 8)}</strong>
            <span>{ep.motivo ?? 'Hospitalización activa'}</span>
          </div>
          {#if onNavigate}
            <button type="button" class="link" onclick={() => onNavigate('altas')}>Dar alta</button>
          {/if}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-elevated); height: 100%; }
  header { display: flex; justify-content: space-between; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--border); }
  h3 { margin: 0; font-size: 0.9rem; }
  header button { border: 1px solid var(--border); background: var(--bg-surface); border-radius: 6px; cursor: pointer; padding: 0.2rem 0.5rem; }
  ul { list-style: none; margin: 0; padding: 0; max-height: 280px; overflow: auto; }
  li { display: flex; justify-content: space-between; gap: 0.5rem; align-items: center; padding: 0.6rem 0.85rem; border-bottom: 1px solid var(--border); }
  strong { display: block; font-size: 0.85rem; }
  span { font-size: 0.78rem; color: var(--text-secondary); }
  .link { border: 0; background: transparent; color: var(--brand-strong); font-size: 0.78rem; cursor: pointer; font-weight: 600; white-space: nowrap; }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
</style>
